import React from 'react';
import FixedBottomNavBar from '../../../../../components/FixedBottomNavBar';
import Button from '../../../../../components/Button';
import './TagGroupEditNavbar.scss';

const TagEditNavbar = (props) => {
  const { onSubmit } = props;

  return (
    <FixedBottomNavBar className="tag-group-edit-navbar">
      <div className="button-group">
        <div className="right">
          <Button color="primary" text="저장" onClick={() => onSubmit()} />
        </div>
      </div>
    </FixedBottomNavBar>
  );
};

export default TagEditNavbar;
